import { useRef } from 'react';
import { Button, CloseIcon, Portal, ThemeIcon } from '@mantine/core';
import {
  notifications,
  useNotifications,
  Notifications,
} from '@mantine/notifications';
import { useTranslation } from 'react-i18next';

export function NotificationsWithClear() {
  const notificationsRef = useRef(null);
  const buttonContainerRef = useRef(null);
  const state = useNotifications();

  return (
    <>
      <Notifications
        ref={(e) => {
          const container = Array.from(e?.parentNode?.children || []).find(
            (x) => x.getAttribute('data-position') == 'top-right',
          );
          notificationsRef.current = container;

          if (container && !buttonContainerRef.current) {
            buttonContainerRef.current = document.createElement('div');
            container.prepend(buttonContainerRef.current);
          }
        }}
        data-testid='notifications-container'
        position='top-right'
      />
      <Portal target={buttonContainerRef.current}>
        <ClearButton count={state.notifications.length + state.queue.length} />
      </Portal>
    </>
  );
}

const ClearButton = ({ count }: { count: number }) => {
  const { t } = useTranslation(['translation', 'settings']);

  return (
    <>
      {count > 1 && (
        <Button
          leftSection={
            <ThemeIcon variant='transparent'>
              <CloseIcon />
            </ThemeIcon>
          }
          fullWidth
          onClick={() => notifications.clean()}
          my='xs'
          data-testid='notifications-clearall-btn'
        >
          {t('translation:action.clearAll')} ({count})
        </Button>
      )}
    </>
  );
};